import { NgModule } from '@angular/core';
import { CollapsiblePanelComponent } from './collapsible-panel.component';
import { CommonModule } from '@angular/common';
import { CollapsiblePanelEvent } from './collapsible-panel-event.interface';

const COMPONENTS = [CollapsiblePanelComponent];

@NgModule({
	exports: COMPONENTS,
	imports: [CommonModule],
	declarations: COMPONENTS
})
class EdAssistUICollapsiblePanelModule {}

export {
	EdAssistUICollapsiblePanelModule,
	CollapsiblePanelComponent,
	CollapsiblePanelEvent
};
